import {
  ApplicationRef,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  Injectable,
  Injector,
  Type
} from '@angular/core';
import { DrawerComponent } from 'src/app/shared/drawer/drawer.component';
import { DrawerRef } from './drawer-ref';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DrawerService {
  constructor(
    private cfr: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  open<T>(component: Type<T>, config: { drawerData?: any } = {}): { afterClosed: () => Observable<any> } {
    const closed$ = new Subject<any>();
  
    const drawerRef = new DrawerRef(config.drawerData);
    
    // Create Drawer Container
    const drawerFactory = this.cfr.resolveComponentFactory(DrawerComponent);
    const drawerComponentRef = drawerFactory.create(
      Injector.create({
        providers: [{ provide: DrawerRef, useValue: drawerRef }],
        parent: this.injector
      })
    );
    this.appRef.attachView(drawerComponentRef.hostView);
    const domElem = (drawerComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  
    // Create Inner Component (inject DrawerRef again)
    const contentFactory = this.cfr.resolveComponentFactory(component);
    const contentRef = drawerComponentRef.instance.contentRef.createComponent(contentFactory);

  
    drawerComponentRef.instance.childComponentRef = contentRef;
  
    // Closing logic
    drawerRef.afterClosed().subscribe(result => {
      this.appRef.detachView(drawerComponentRef.hostView);
      drawerComponentRef.destroy();
      closed$.next(result);
      closed$.complete();
    });
  
    return {
      afterClosed: () => drawerRef.afterClosed()
    };
  }
}
